import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=48b594fb&"
import script from "./CardAction.vue?vue&type=script&lang=js&"
export * from "./CardAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports